
export default {
  BREAK_POINT: 960,
}
